import SingleSelectStep from "@/components/steps/SingleSelectStep";
import MultiSelectStep from "@/components/steps/MultiSelectStep";
import FormStep from "@/components/steps/FormStep";
import InfoStep from "@/components/steps/InfoStep";
import LoadingStep from "@/components/steps/LoadingStep";
import SummaryStep from "@/components/steps/SummaryStep";

const StepRenderer = ({ step, stepNumber }) => {
  if (!step) return null;

  const commonProps = {
    step,
    stepNumber,
  };

  switch (step.type) {
    case "singleSelect":
      return <SingleSelectStep key={stepNumber} {...commonProps} />;

    case "multiselect":
      return <MultiSelectStep key={stepNumber} {...commonProps} />;

    case "form":
      return <FormStep key={stepNumber} {...commonProps} />;

    case "info":
      return <InfoStep key={stepNumber} {...commonProps} />;

    case "loading":
      return <LoadingStep key={stepNumber} {...commonProps} />;

    case "summary":
      return <SummaryStep key={stepNumber} {...commonProps} />;

    default:
      return <div>Unknown step type: {step.type}</div>;
  }
};

export default StepRenderer;
